module.exports = __webpack_public_path__ + "static/media/inr_logo_anim.4731ad48.glb";